// University Settings - Main barrel export
// Import from "@/constants/admin/universitySettings" for all university settings

// Types & Constants
export {
  SETTING_KEYS,
  COMMON_CONSTANTS,
  type UniversitySettingKey,
  type UniversitySettingConfig,
  type VariantConfig,
} from "./types";

// Variant Configurations
export {
  LEAD_DROP_POPUP_VARIANTS_CONFIG,
  LEAD_DROP_FORM_VARIANTS_CONFIG,
  COURSES_VARIANTS_CONFIG,
  HIGHER_QUALIFICATION_VARIANTS_CONFIG,
  UNIVERSITY_VARIANTS_CONFIG,
  getLeadDropPopupVariantDetails,
  getLeadDropFormVariantDetails,
  getCourseVariantDetails,
  getHigherQualificationVariantDetails,
  getUniversityVariantDetails,
} from "./variants";

// Main Configuration & Helpers
export {
  UNIVERSITY_SETTINGS_CONFIG,
  getUniversitySettingConfig,
  getAllUniversitySettingConfigs,
  getVariantDetails,
} from "./config";

// Re-exports from sectionTypes (for convenience)
export {
  UNIVERSITY_SETTINGS_SECTION_TYPES,
  UNIVERSITY_ID,
} from "../sectionTypes";

// Re-export API function
export { upsertUniversitySettings } from "@/api/admin/universitySettings";

